var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-view"},[_c('div',{staticClass:"container-scroller"},[_c('Header',{attrs:{"is-special-route":_vm.isSpecialRoute},on:{"nav-visibility":_vm.onNavVisibility,"user-logout":_vm.onUserLogout}}),_c('div',{staticClass:"container-fluid page-body-wrapper",class:[
                    'client-dashbboard',
                    {
                        Homescreen: _vm.isHomePage,
                        LoggedIn: _vm.showAfterLogin,
                        'english-header': _vm.selectedLanguage === 'en',
                        'has-bookings': _vm.navShowBooking === true,
                        'no-bookings': _vm.navShowBooking === false,
                        'has-manage-dashboard': _vm.navShowManage === true,
                        'no-manage-dashboard': _vm.navShowManage === false
                    }
                ]},[_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('Footer')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }